import React, { useState, useEffect } from "react";
import { Table, Label, Badge } from "reactstrap";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import UserHeader from "../../../components/Headers/AboutHeader.js";
import { SocialIcon } from "react-social-icons";
import Typography from "@mui/material/Typography";

const Profilegroup = () => {
  return (
    <>
      <UserHeader />
      <Grid container direction="row">
        <Grid className="order-xl-1">
          <Card body inverse className="d-flex align-items-center">
            <CardContent tag="h5">
              <Typography
                gutterBottom
                style={{ textAlign: "left" }}
                className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600"
              >
                Safeguarding IT systems against cyber threats would take lot of
                time and require many meetings between IT and Security teams to
                debate and finalize the complience standards.
              </Typography>
              <Typography
                gutterBottom
                style={{ textAlign: "left" }}
                className="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-600"
              >
                Center For information security(CIS) has developed CIS
                Benchmarks for operating systems, applications and cloud
                platforms. But applying them to individual systems and auditing
                their current state is impracticable.
              </Typography>
              <Typography
                gutterBottom
                style={{ textAlign: "left" }}
                className="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-600"
              >
                AutomateCIS can do the heavy lifting of keeping your
                infrastructure up to date with CIS standards in a few simple
                steps.
              </Typography>
            </CardContent>
          </Card>
          <br />
          <Card
            body
            inverse
            className="d-flex align-items-center"
            style={{ backgroundColor: "#fbdd05", borderColor: "#333" }}
          >
            <CardContent tag="h5">
              <Typography
                gutterBottom
                style={{ fontWeight: "bold", textAlign: "center" }}
              >
                Let's Start Automation Journey Together
              </Typography>
              <Typography style={{ textAlign: "center" }}>
                ‌With our Enterprise Automation consulting, we help large,
                medium enterprises and startups achieve higher efficiency in
                Development and Operations, quicker time to market, the better
                quality of software builds, and secure delivery of software with
                early identification of emerging issues, without security
                weaknesses and letting the code be in a releasable state always.
              </Typography>
              <br />
              <Typography style={{ textAlignLast: "center" }}>
                <Button
                  className="align-items-center"
                  style={{ textAlign: "center" }}
                  style={{ backgroundColor: "#333", color: "#fbdd05" }}
                  href="https://www.zippyops.com/contact-us"
                  target="_blank"
                >
                  Contact Us
                </Button>
              </Typography>
            </CardContent>
          </Card>
          <br />
          <br />
          <Card
            body
            inverse
            className="d-flex align-items-center"
            style={{ backgroundColor: "#333", borderColor: "#333" }}
          >
            <Grid container direction="row">
              <Grid className="order-xl-2 mts-4 mbs-3 mb-xl-0" xl="6">
                <CardContent className="text-white">
                  <Typography style={{ fontWeight: "bold" }}>
                    ZippyOPS Consulting Services{" "}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong> support@zippyops.com
                  </Typography>
                  <Typography>
                    <strong>phone:</strong> +91-7010585768, +91-8903067727
                  </Typography>
                </CardContent>
              </Grid>
              <Grid className="order-xl-2 mt-4 mb-3 mb-xl-0" xl="6">
                <CardContent className="text-white">
                  <Typography>
                    <strong>Address:</strong>
                  </Typography>
                  <Typography>
                    No. 209/210, 1st Floor J Nagar, ‌Panaiyur Kuppam Main Road,
                    Panaiyur, Chennai, Tamil Nadu 600097
                  </Typography>
                  <Typography>
                    <SocialIcon
                      target="blank"
                      url="https://twitter.com/ZippyOps"
                      network="twitter"
                      fgColor="#fff"
                      style={{ height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://facebook.com/zippyops"
                      network="facebook"
                      fgColor="#fff"
                      style={{ marginLeft: "1em", height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://instagram.com/zippyops"
                      network="instagram"
                      fgColor="#fff"
                      style={{ marginLeft: "1em", height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://youtube.com/channel/UCZh2aijMM-h6ztRo36m3CiQ"
                      network="youtube"
                      fgColor="#fff"
                      style={{ marginLeft: "1em", height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://linkedin.com/in/zippyops"
                      network="linkedin"
                      fgColor="#fff"
                      style={{ marginLeft: "1em", height: 35, width: 35 }}
                    />
                    <SocialIcon
                      target="blank"
                      url="https://t.me/ZippyOPS"
                      network="telegram"
                      fgColor="#fff"
                      style={{ marginLeft: "1em", height: 35, width: 35 }}
                    />
                  </Typography>
                </CardContent>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default Profilegroup;